import React from 'react';

const TitleContext = React.createContext();

export default TitleContext;